import { Box, Popover, PopoverProps } from '@mui/material';
import { PropsWithChildren } from 'react';

type ListFilterPopoverProps = Pick<PopoverProps, 'open' | 'anchorEl' | 'onClose'>;

export default function ListFilterPopover({
  open,
  anchorEl,
  onClose,
  children,
}: PropsWithChildren<ListFilterPopoverProps>) {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      {open ? children : <Box sx={{ width: '250px' }} />}
    </Popover>
  );
}
